import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { consumeReturnTo } from '../../services/returnTo';

interface Props {
  children: ReactNode;
}

/**
 * After Google login the backend lands the browser on "/". If the user was sent to login
 * from a deep link (e.g. a shared catalog), send them back there instead of showing HomePage.
 */
export default function ReturnToRedirect({ children }: Props) {
  const returnTo = consumeReturnTo();

  if (returnTo) {
    return <Navigate to={returnTo} replace />;
  }

  return <>{children}</>;
}
